









import Vue from 'vue'
import FileUpload from '@/UI/Shared/FileUpload/FileUpload.vue'

interface UploaderOptions {
  [key: string ]: string | number | boolean;
}

export default Vue.extend({
  name: 'DocumentUploader',
  components: { FileUpload },
  props: {
    procedureId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    fileName: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    options (): UploaderOptions {
      return {
        url: this.getBaseUrl,
        acceptedFiles: 'application/pdf,.zip',
        maxFilesize: 30,
        maxFiles: 1,
        chunkSize: 500,
        createImageThumbnails: false,
        thumbnailWidth: 100,
        thumbnailHeight: 100,
        addRemoveLinks: true,
        dictDefaultMessage: this.$t('shared.fileUpload.dictDefaultMessage').toString(),
        dictFallbackMessage: this.$t('shared.fileUpload.dictFallbackMessage').toString(),
        dictFallbackText: this.$t('shared.fileUpload.dictFallbackText').toString(),
        dictFileTooBig: this.$t('shared.fileUpload.dictFileTooBig').toString(),
        dictBadExtension: this.$t('shared.fileUpload.dictBadExtension').toString(),
        dictResponseError: this.$t('shared.fileUpload.dictResponseError').toString(),
        dictCancelUpload: this.$t('shared.fileUpload.dictCancelUpload').toString(),
        dictUploadCanceled: this.$t('shared.fileUpload.dictUploadCanceled').toString(),
        dictCancelUploadConfirmation: this.$t('shared.fileUpload.dictCancelUploadConfirmation').toString(),
        dictRemoveFile: this.$t('shared.fileUpload.dictRemoveFile').toString(),
        dictMaxFilesExceeded: this.$t('shared.fileUpload.dictMaxFilesExceeded').toString()
      }
    },
    getBaseUrl (): string {
      if (process.env.VUE_APP_API_ENV === 'local') {
        return 'https://httpbin.org/post'
      }
      return process.env.VUE_APP_API_URL + `/sobree/api/documentation/${this.procedureId}/${this.userId}`
    }
  },
  methods: {
    onFileAddComplete (name: string) {
      this.$emit('file-upload-success', name)
    }
  }
})
